import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { localstore } from '../utils/localForageStorage';
import logger from 'redux-logger';

import authReducer from './auth';
//import siteadminauthReducer from './authsiteadmin';
import loadingReducer from './loading-reducer'
import layoutBannerReducer from './layout-banner-reducer';
import sentReducer from './sent';
import { setUsingAPICall } from './settings'
import reportReducer from './report';
import messageTemplateReducer from './messagetemplate';
import groupReducer from './groups';
import composeReducer from './compose';
import inboxReducer from './messageInbox';
import settingsReducer from './settings';
import axiosInstance from '../utils/api';
import axiosInstanceClientApi from '../utils/clientApi';
import axiosInstanceImportApi from '../utils/importApi';
import { apiErrorHandler, apiSuccessHandler } from '../helpers/responseHandler';
const authPersistConfig = {
	key: 'root',
	storage: localstore
}



const rootReducer = combineReducers({
	auth: persistReducer(authPersistConfig, authReducer), //siteadminauthReducer.refreshToken == null ? persistReducer(authPersistConfig, authReducer)
		//: persistReducer(authPersistConfig, siteadminauthReducer),
	loading: loadingReducer,
	layoutBanner: layoutBannerReducer,
	sentlists: sentReducer,
	reportlists: reportReducer,
	messagetemplatelist: messageTemplateReducer,
	grouplists: groupReducer,
	compose: composeReducer,
	inboxlists: inboxReducer,
	settings: settingsReducer
})

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: true,
			serializableCheck: true,
		}).concat(logger),
	devTools: process.env.NODE_ENV !== "production",
});


//To set up axios instance after initialising store
const axiosInterceptor = (store) => {

	axiosInstance.interceptors.request.use(
		function (config) {
			const state = store.getState()
			config.headers = {
				"Content-Type": "application/json",
				"Authorization": state.auth.token ? `Bearer ${state.auth.token}` : "",
				...config.headers,
			};
			store.dispatch(setUsingAPICall())
			return config;
		},
		function (error) {
			return Promise.reject(error);
		}
	);

	axiosInstance.interceptors.response.use(apiSuccessHandler, apiErrorHandler)
}

axiosInterceptor(store);

const axiosInterceptorClientApi = () => {

	axiosInstanceClientApi.interceptors.request.use(
		function (config) {
			config.headers = {
				"Content-Type": "application/json",
				...config.headers,
			};
			return config;
		},
		function (error) {
			return Promise.reject(error);
		}
	);

	axiosInstanceClientApi.interceptors.response.use(apiSuccessHandler, apiErrorHandler)
}

axiosInterceptorClientApi(store);


const axiosInterceptorImportApi = () => {

	axiosInstanceImportApi.interceptors.request.use(
		function (config) {
			config.headers = {
				"Content-Type": "application/json",
				...config.headers,
			};
			return config;
		},
		function (error) {
			return Promise.reject(error);
		}
	);

	axiosInstanceImportApi.interceptors.response.use(apiSuccessHandler, apiErrorHandler)
}

axiosInterceptorImportApi(store);

export const persistor = persistStore(store)
